module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2l"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "pt01ch04"
    }
  }, [_vm._v("chapter four")])]), _c('a', {
    attrs: {
      "id": "pt01ch04"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("When the bell rang dismissing school for the day, I dashed to the front doors to meet Maya for our after-school study session. We were prepping for a test in first-period English on "), _c('em', [_vm._v("The Grapes of Wrath")]), _vm._v(". I’d actually read this one and was ready to go, though the ending grossed me out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Breast-feeding an old guy? Nasty. Who decided to make "), _c('em', [_vm._v("that")]), _vm._v(" a classic?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Andy, who was outside yapping with Maya, wasn’t going to get her nerd groove on with the two of us, since she wasn’t in me and Maya’s English class. However, it was tradition for the three of us to walk home together.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pt01ch04"
    }
  }, [_vm._v("We headed down the icy sidewalk. Luckily, Maya’s house was only ")]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("a few blocks away. In thin pants, I was freezing my buns off. I rubbed my hands together, then crammed them in my coat pockets, wishing I’d remembered my gloves.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you hear?” Andy asked, shouldering her backpack a little better over her coat. Her breath huffed out in little clouds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hear what?” I asked, eager for her to dish details. Andy always had the good scoop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mallory Robinson was flirting way hard with Derek today at second lunch. Jenny Mack was sitting across the table from them, and she told Amanda West, who told me. Mallory’s probably doing it just because she knows you like him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My stomach clenched. “God, seriously?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mallory Robinson was my mortal enemy, and if there was a way for her to make my life miserable, she was after it. It looked like flirting with Derek was a new addition to her “let’s torture Felicity” list.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you going to do about it?” Maya asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know,” Andy volunteered. “You should tell Derek you like him before that piece of trash steals him away.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Man, I wished I could. If only the cupid law was different. But I couldn’t just throw some e-mail love his way and make him ")]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("come running to me. And without the cupid magic, he barely knew I was alive.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know,” I said. “I guess I’ll figure something out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This sucked. The one guy I’d been in love with forever was off-limits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Or was he?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janet had told me I couldn’t matchmake myself. But that didn’t mean I couldn’t be available if "), _c('em', [_vm._v("he")]), _vm._v(" wanted to date "), _c('em', [_vm._v("me")]), _vm._v(", right? If I could get him to fall for me without using the magic, it wouldn’t be breaking any cupid rules.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But how on earth was I going to do that? I needed to think about this more. There had to be something I could do to make Derek notice me. If he ended up with Mallory, I swear I’d spontaneously combust.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once Maya and I arrived at her house, we darted inside, waving bye to Andy, and ran upstairs to her bedroom. Maya hopped onto her computer to check e-mail, as usual.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, this time was different. I’d get to watch my love match in action.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("As she booted up her PC, my heart pounded, and I realized my hands were shaking slightly. What if I messed it up? What if she realized what I was doing? What if the triple-match strategy ")]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("backfired, and the guys all fell for each other instead of for Maya? I stuffed my hands in my pockets to keep from showing my nervousness. “Um …”")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hold on a sec, Felicity. I got e-mail.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sat on her bed and nodded, holding my breath for what seemed like an eternity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maya double-clicked with the mouse, then froze. She stared at the monitor. After a moment, she shook her head, blinking. “What were we talking about?” she asked, rubbing the middle of her chest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It worked! She must have been feeling the same tingle I’d experienced when Janet hit me with the arrow. “Oh, you know,” I said oh so casually, “just talking about guys.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She spun in her seat and looked at me, a dreamy smile on her face. It almost freaked me out—I’d never seen her look … blissful before. With her face so soft, she almost looked like a different person.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know who I like?” She sighed, putting her hand to her heart. “Josh Wiley, Ben Johnson, and Quentin Lovejoy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Bingo.")])]), _c('p', {
    staticClass: "noindenta"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("That afternoon, after studying with Maya and running home quickly to change clothes, I bummed Mom’s car and made my way to Cupid’s ")]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("Hollow headquarters, where I was scheduled for my first one-on-one meeting with my boss to discuss the state of my cupid affairs for the week.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Janet had been pretty friendly during my interview and training session, but now that I was a true employee, I quickly found out that she could be plenty intimidating when she wanted to. She sat at her desk like a dictator at a podium, peering down her nose at me. Or maybe she just seemed extra scary since I was terrified I’d get fired for having already broken a rule in my first week on the job.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Trying to remain as calm and professional as possible, I filled her in on my pair-ups for Britney and Maya, using generic statements for Maya’s match and carefully omitting the part about having carbon-copied all three guys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a brisk nod, Janet said, “Sounds like you’ve done a good job so far, Felicity.” She wrote a note in her ever-present notebook. “So, you made one match last week and one this week. Way to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shifted in my seat. Nervous as hell, I’d dressed to impress in my best outfit—a semisheer white blouse, lacy white tank top, and deep blue A-line skirt. Unfortunately, the skirt was also made of the itchiest fabric known to mankind.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("I’d bought it because it was super cute, but every time I wore it, ")]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("I ended up scratching myself like I had fleas. Not very attractive.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks,” I said to Janet. “It’s been fun so far.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, why don’t you hand over your LoveLine 3000 so I can upload your information into the main computer. I can also port updated e-mail addresses to you this way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At her words, my heart stopped beating and nearly jumped out of my chest. I hadn’t realized she’d actually want to "), _c('em', [_vm._v("see")]), _vm._v(" the matches. If I handed her the PDA, she’d know instantly that I’d matched Maya up with three guys, thus breaking a cupid rule. Would she buy my “gut” reasoning?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instinct told me not to find out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, I left it at home,” I said, pasting on a huge, fake smile. With my heel, I subtly nudged my purse—the one that currently held said PDA—under my chair. “That was so stupid of me. I can bring it in next time, though. Will that work?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure,” she replied, “but please bring it in then.” She glanced at her watch. “Okay, you’re free to go. I’ll see you next Monday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sweet, blissful relief surged through my limbs. Thank God I’d have time to delete Maya’s match and claim it was an “accident.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stood and shook her hand. “You got it!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("“If you feel comfortable with it,” she said as I slid my arms ")]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("into my coat, “try upping your quota to two matches this week.”")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded. “Absolutely. I can do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, wait.” She flipped through a manila folder on her desk, then handed me a check. “Here you go. I’ll be paying you weekly at our meetings.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I grinned widely. “Thanks!” "), _c('em', [_vm._v("Sweet!")]), _vm._v(" It wasn’t a land mine, but I’d earned this paycheck. And I was doubly happy to find out I’d be getting paid weekly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the meeting, I hopped in Mom’s Camry and pulled out of the parking lot, giddy with relief. I’d managed to avert certain disaster and keep my awesome job. Janet had praised my matches and even upped my quota. And tomorrow, I’d get to witness the biggest payoff of all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boy, would Maya be surprised when the three guys started wooing her! I couldn’t wait to see her happy face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was seriously the best friend ever. Of course, Maya would never know I was the reason for her dating surge, but that didn’t matter. It would be my little anonymous contribution to the whole “pay it forward” concept.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("About a mile from my house, I shifted the car into the right lane. Suddenly, a wailing siren appeared from out of nowhere behind me, ")]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("and blue and red lights flashed in my rearview mirror.")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But I wasn’t speeding or anything! And I’d even used my turn signal (which, I freely admit, I sometimes forget about). Crap, I was in serious trouble now. Mom would kill me for getting a ticket while driving her car.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pull over!” a loud voice barked over the police car’s megaphone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With shaky hands, I sucked in shallow breaths and did as instructed, parking on the side of the road. I dug into my purse to find my license, barely able to concentrate. I was in such deep sh—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The megaphone interrupted my thoughts. “Ma’am, we know you’re using the marijuana!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I clenched my jaw. I’d know that irritating voice from anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pissed off, I hopped out of the car, stomped to my brother’s cop car, and stood by his door, hands on hips. I cussed loudly, scaring an old lady crossing the street. She blinked at me and walked faster, trying to get away from me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Geez, Rob, you scared the piss out of me!” I yelled. “I thought I was in real trouble. You’re such a jerk.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rob and his partner were in the front seat, bent over laughing. Rob straightened, then said through the megaphone, “Stop cussing at me or I’m going to have to take you in.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("I shot him the most evil glare I could muster. “Stop pulling me over!” I shouted at him through the window. “This is the second time now you’ve done this to me. It’s still not funny.”")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He rolled down his window and stuck his head out. “Then, ma’am, stop driving in this city.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I live here!” I turned on my heel and headed back to the car.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And, ma’am,” Rob hollered to my back, his voice ringing loud and clear throughout all of Cleveland, no doubt, “lay off the spray tan! Your skin’s starting to look orange.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I whirled back around and stomped toward him, unable to control my rage. “If you pull me over again,” I said, pointing my finger in his face, “I’ll tell Mom about the time I caught you making out with Cindy Masterson in Mom and Dad’s bed when you two were supposed to be studying.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His jaw dropped. He tried to cover up his fear, but I could see it in his eyes. “You wouldn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I leaned close to his face, then widened my eyes and blinked rapidly, gasping. “Mom, it was awful! He was touching her under her shirt! I didn’t know "), _c('em', [_vm._v("what")]), _vm._v(" to do!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rob stared at me for a long moment, then tipped his hat. “Have a nice day.” He drove off in a hurry.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5870cc31","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/pt01ch04.vue
// module id = 84
// module chunks = 0